// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/Georama_SemiCondensed-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Georama:wght@400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Georama SemiCondensed";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 400;
}

body {
    margin: auto;
    line-height: normal;
    font-family: var(--font-lato);
    font-size: 1rem;
    height: 100%;
    color: var(--secondary-color);
}

:root {
    /* fonts */
    --title: "Georama SemiCondensed";
    --font-lato: Lato;
    --navbar1: Georama;

    /* font sizes */
    --title-1-desktop-size: 3rem;
    --title-1-tablet-size: 2.5rem;
    --title-2-desktop-size: 2.2rem;
    --title-2-tablet-size: 1.6rem;
    --title-3-desktop-size: 1.75rem;
    --title-3-tablet-size: 1.375rem;
    --title-4-desktop-size: 1.5rem;
    --title-4-tablet-size: 1.19rem;
    --title-5-desktop-size: 1.25rem;
    --title-5-tablet-size: 1rem;

    /* Colors */
    --primary-color: #e40032;
    --secondary-color: #333f4c;
    --gray: #D9D9D9;
    --lightGray: #F7F6F7;
    --white: #fff;
    --info-color: #1581BF;
    --success-color: #8BC74E;
    --warning-color: #ECAA07;
    --pending-color: #e5e912;

    /* Gaps */
    --gap-md: 0.31rem;
    --gap-lg: 1rem;

    /* Paddings */
    --padding-sm: 1.38rem;
    --padding-md: 3rem;
}

.section {
    margin: auto;
    margin-top: 3rem;
}

.displayFlexCenter {
    display: flex;
    justify-content: center;
    align-items: center;
}

.spaceBetweenContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.spaceBetweenContainerStart {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.flexWrap {
    display: flex;
    flex-wrap: wrap;
}

.flexWrapStart {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}

.flexWrapSpaceBetween {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.flexColumnContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.flexColumnContainerAlignStart {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
}

.userCard {
    width: 70%;
    margin: 0 auto;
    padding: 2rem;
    border-radius: 0.5rem;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
}

.cardBody {
    padding-top: 2rem;
}

.formContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
}

.mediumContainer {
    width: 48%;
}

.largeContainer {
    width: 90%;
}

.badgeContainer {
    width: 11rem;
}

.select {
    margin-bottom: 1rem;
}

textarea,
p {
    text-align: justify;
}

.link {
    margin-top: 2rem;
}

.actionIcon {
    margin-right: 0.5rem;
    cursor: pointer;
}

.actionIcon:hover {
    color: var(--primary-color);
}

.button {
    width: 8.75rem;
    cursor: pointer;
    margin: 2rem 2rem 1rem 0;
}

.fit {
    width: -moz-fit-content;
    width: fit-content;
}

.largeButton {
    width: 90%;
    margin-top: 2rem;
}

.message {
    display: none;
    color: var(--primary-color);
}

li:hover {
    background-color: var(--gray);
    cursor: pointer;
}

.footerContainer {
    bottom: 0;
    position: absolute;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAGA;IACI,oCAAoC;IACpC,4CAAuD;IACvD,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;;IAElB,eAAe;IACf,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;IAC9B,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;IAC/B,8BAA8B;IAC9B,8BAA8B;IAC9B,+BAA+B;IAC/B,2BAA2B;;IAE3B,WAAW;IACX,wBAAwB;IACxB,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,qBAAqB;IACrB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,SAAS;IACT,iBAAiB;IACjB,cAAc;;IAEd,aAAa;IACb,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Georama:wght@400&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap\");\r\n\r\n@font-face {\r\n    font-family: \"Georama SemiCondensed\";\r\n    src: url(\"../public/Georama_SemiCondensed-Regular.ttf\");\r\n    font-weight: 400;\r\n}\r\n\r\nbody {\r\n    margin: auto;\r\n    line-height: normal;\r\n    font-family: var(--font-lato);\r\n    font-size: 1rem;\r\n    height: 100%;\r\n    color: var(--secondary-color);\r\n}\r\n\r\n:root {\r\n    /* fonts */\r\n    --title: \"Georama SemiCondensed\";\r\n    --font-lato: Lato;\r\n    --navbar1: Georama;\r\n\r\n    /* font sizes */\r\n    --title-1-desktop-size: 3rem;\r\n    --title-1-tablet-size: 2.5rem;\r\n    --title-2-desktop-size: 2.2rem;\r\n    --title-2-tablet-size: 1.6rem;\r\n    --title-3-desktop-size: 1.75rem;\r\n    --title-3-tablet-size: 1.375rem;\r\n    --title-4-desktop-size: 1.5rem;\r\n    --title-4-tablet-size: 1.19rem;\r\n    --title-5-desktop-size: 1.25rem;\r\n    --title-5-tablet-size: 1rem;\r\n\r\n    /* Colors */\r\n    --primary-color: #e40032;\r\n    --secondary-color: #333f4c;\r\n    --gray: #D9D9D9;\r\n    --lightGray: #F7F6F7;\r\n    --white: #fff;\r\n    --info-color: #1581BF;\r\n    --success-color: #8BC74E;\r\n    --warning-color: #ECAA07;\r\n    --pending-color: #e5e912;\r\n\r\n    /* Gaps */\r\n    --gap-md: 0.31rem;\r\n    --gap-lg: 1rem;\r\n\r\n    /* Paddings */\r\n    --padding-sm: 1.38rem;\r\n    --padding-md: 3rem;\r\n}\r\n\r\n.section {\r\n    margin: auto;\r\n    margin-top: 3rem;\r\n}\r\n\r\n.displayFlexCenter {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.spaceBetweenContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.spaceBetweenContainerStart {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n}\r\n\r\n.flexWrap {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.flexWrapStart {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: flex-start;\r\n}\r\n\r\n.flexWrapSpaceBetween {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n}\r\n\r\n.flexColumnContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.flexColumnContainerAlignStart {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.userCard {\r\n    width: 70%;\r\n    margin: 0 auto;\r\n    padding: 2rem;\r\n    border-radius: 0.5rem;\r\n    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.cardBody {\r\n    padding-top: 2rem;\r\n}\r\n\r\n.formContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 1.5rem;\r\n}\r\n\r\n.mediumContainer {\r\n    width: 48%;\r\n}\r\n\r\n.largeContainer {\r\n    width: 90%;\r\n}\r\n\r\n.badgeContainer {\r\n    width: 11rem;\r\n}\r\n\r\n.select {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\ntextarea,\r\np {\r\n    text-align: justify;\r\n}\r\n\r\n.link {\r\n    margin-top: 2rem;\r\n}\r\n\r\n.actionIcon {\r\n    margin-right: 0.5rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.actionIcon:hover {\r\n    color: var(--primary-color);\r\n}\r\n\r\n.button {\r\n    width: 8.75rem;\r\n    cursor: pointer;\r\n    margin: 2rem 2rem 1rem 0;\r\n}\r\n\r\n.fit {\r\n    width: fit-content;\r\n}\r\n\r\n.largeButton {\r\n    width: 90%;\r\n    margin-top: 2rem;\r\n}\r\n\r\n.message {\r\n    display: none;\r\n    color: var(--primary-color);\r\n}\r\n\r\nli:hover {\r\n    background-color: var(--gray);\r\n    cursor: pointer;\r\n}\r\n\r\n.footerContainer {\r\n    bottom: 0;\r\n    position: absolute;\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
